import { render, staticRenderFns } from "./KeywordsTable.vue?vue&type=template&id=06ce5408&scoped=true&"
import script from "./KeywordsTable.vue?vue&type=script&lang=js&"
export * from "./KeywordsTable.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsTable.vue?vue&type=style&index=0&id=06ce5408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce5408",
  null
  
)

export default component.exports